import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { StateService } from '../../services/state.service';
import { SidebarService } from '../../services/sidebar.service';
import { CommonModule } from '@angular/common';
import { AppSidebarComponent } from '../app-sidebar/app-sidebar.component';
import { BackdropComponent } from '../backdrop/backdrop.component';
import { RouterModule } from '@angular/router';
import { AppHeaderComponent } from '../app-header/app-header.component';
import { PasswordExpiryBannerComponent } from '../../components/password-expiry-banner/password-expiry-banner.component';

@Component({
  selector: 'app-layout',
  imports: [
    CommonModule,
    RouterModule,
    AppHeaderComponent,
    AppSidebarComponent,
    BackdropComponent,
    PasswordExpiryBannerComponent,
  ],
  templateUrl: './app-layout.component.html',
})

export class AppLayoutComponent {
  readonly isExpanded$;
  readonly isHovered$;
  readonly isMobileOpen$;

  constructor(
    public sidebarService: SidebarService,
    private readonly router: Router,
    private readonly stateService: StateService
  ) {
    this.isExpanded$ = this.sidebarService.isExpanded$;
    this.isHovered$ = this.sidebarService.isHovered$;
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;

    // Clear unrelated table states when navigating between main sections
    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe((e) => {
      const url = e.urlAfterRedirects || e.url || '';
      if (!url.startsWith('/abuse')) {
        this.stateService.removeState('abuseTableState');
        this.stateService.removeState('abuseTableColumns');
      }
      if (!url.startsWith('/email')) {
        this.stateService.removeState('emailTemplateTableState');
        this.stateService.removeState('emailTemplateTableColumns');
      }
      if (!url.startsWith('/monitor')) {
        this.stateService.removeState('monitorTableState');
        this.stateService.removeState('monitorTableColumns');
      }
    });
  }

  get containerClasses() {
    return [
      'flex-1',
      'transition-all',
      'duration-300',
      'ease-in-out',
      (this.isExpanded$ || this.isHovered$) ? 'md:ml-[290px]' : 'md:ml-[90px]',
      this.isMobileOpen$ ? 'ml-0' : ''
    ];
  }

}
